/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Orders_Not_Green_ReviewedInputs */

const en_orders_not_green_reviewed = /** @type {(inputs: Orders_Not_Green_ReviewedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} not green-reviewed`)
};

const es_orders_not_green_reviewed = /** @type {(inputs: Orders_Not_Green_ReviewedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} no tienen revision verde`)
};

/**
* | output |
* | --- |
* | "{count} not green-reviewed" |
*
* @param {Orders_Not_Green_ReviewedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_not_green_reviewed = /** @type {((inputs: Orders_Not_Green_ReviewedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Not_Green_ReviewedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_not_green_reviewed(inputs)
	return es_orders_not_green_reviewed(inputs)
});